import { formatUOSNumber } from './panelNumbers';

export const reassignSwitchUOS = (switches, switchIdx, selection) => {
  const selectedUOS = formatUOSNumber(selection);
  const currentSwitch = switches[switchIdx];
  const destinationPanel = switches.find(
    (eachSwitch, idx) =>
      idx !== switchIdx &&
      formatUOSNumber(eachSwitch.UOS) === selectedUOS &&
      eachSwitch.deviceMac,
  );
  // The panel being left behind only outlives this switch if a sibling stays on
  // it. When none does, the panel itself is what moved, and its MAC has to
  // travel with it: a renumbered panel used to arrive at the server with no
  // device_mac, and the server answered by minting a second device for a panel
  // it already had — one leaked device per save.
  const panelStaysBehind = switches.some(
    (eachSwitch, idx) =>
      idx !== switchIdx &&
      formatUOSNumber(eachSwitch.UOS) === formatUOSNumber(currentSwitch.UOS),
  );

  return switches.map((eachSwitch, idx) =>
    idx === switchIdx
      ? {
          ...eachSwitch,
          UOS: selectedUOS,
          deviceMac:
            destinationPanel?.deviceMac ??
            (panelStaysBehind ? null : currentSwitch.deviceMac ?? null),
        }
      : eachSwitch,
  );
};
